import {
    AgentUserId
} from 'one-state-getuserid/src/model';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Epic User Id Component
 * @param response has the backend
 * Epic User Id  component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result :any = {
        agentiddata:[],
        error:undefined
    }

    const { log,settings } = context;
    const { compatible: { sso,contact_center_type } } = settings;
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }

    if (response) {
       
        let info: AgentUserId = {
            agentuserid: "",
            modalvisible: true,
            }
        let agentinfo:AgentUserId[] =[]
        if(response.length > 0) {
            response.forEach((ele: any) => {
                
                if(ele) {
                    if(contact_center_type === "finesse" || contact_center_type === "five9" ||
                    contact_center_type === "vonage" ||
                    contact_center_type === "twilio" ||
                    contact_center_type === "inContact" || contact_center_type === "ringcx" ||
                    contact_center_type === "genesys" ||
                    contact_center_type === "wxcc" ||
                    contact_center_type === "intermedia" ||
                    contact_center_type === "ringcentral" || contact_center_type === "glia") {
                        info.agentuserid = ele?.panviva_user;
                    }
                    info.modalvisible = false;
                }
                agentinfo.push(info)
            });
            result.agentiddata=agentinfo;   
        }
        else if(response.length === 0 && sso === true) {
            info.agentuserid = "";
            info.modalvisible = false;
            agentinfo.push(info)
            result.agentiddata=agentinfo;
        }
        else if(response.length === 0 && sso === false) {
            agentinfo.push(info);
            result.agentiddata=agentinfo;  
        }
        
    }
    log.debug(
        "ccw-gadget,Agent-epic",
        "Agent-epic transformation response ", {
        result
    });
    return result;
}